<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" :atras="atras" />

        <h5 class="regisTituloUsuario">Hola, {{ this.datausuario.primer_nombre }} {{ this.datausuario.primer_apellido }}
        </h5>
        <!-- <h5 class="regisTituloUsuario">Tu perfil es :  {{this.perfil}} </h5>   -->
        <br />
        <b-row>
            <b-col>
                <b-card no-body class="overflow-hidden carddas" style="max-width: 540px;">
                    <b-row no-gutters>
                        <b-col md="7" class="center">
                            <b-card-text class="paddincard">
                                <b>Solicitudes en estado nuevo.</b>
                                <div><b>Total 2</b></div>
                            </b-card-text>
                        </b-col>
                        <b-col md="5">
                            <b-icon class="iconocard" stacked icon="bar-chart-steps"></b-icon>

                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col>
                <b-card no-body class="overflow-hidden carddas" style="max-width: 540px;">
                    <b-row no-gutters>
                        <b-col md="7" class="center">
                            <b-card-text class="paddincard">
                                <b>Solicitudes tomadas.</b>
                                <div><b>Total 2</b></div>
                            </b-card-text>
                        </b-col>
                        <b-col md="5">
                            <b-icon class="iconocard" stacked icon="building"></b-icon>

                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col>
                <b-card no-body class="overflow-hidden carddas" style="max-width: 540px;">
                    <b-row no-gutters>
                        <b-col md="7" class="center">
                            <b-card-text class="paddincard">
                                <b>Solicitudes rechazadas.</b>
                                <div><b>Total 2</b></div>
                            </b-card-text>
                        </b-col>
                        <b-col md="5">
                            <b-icon class="iconocard" stacked icon="book"></b-icon>

                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col>
                <b-card no-body class="overflow-hidden carddas" style="max-width: 540px;">
                    <b-row no-gutters>
                        <b-col md="7" class="center">
                            <b-card-text class="paddincard">
                                <b>Solicitudes finalizadas.</b>
                                <div><b>Total 2</b></div>
                            </b-card-text>
                        </b-col>
                        <b-col md="5">
                            <b-icon class="iconocard" stacked icon="archive"></b-icon>

                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <br />
        <!-- Imagen principal siempre visible -->
        <img src="https://i.ibb.co/Mk9Q6Tn/DALL-E-2024-11-29-10-58-34-A-visually-striking-graphic-chart-displaying-performance-indicators-for-a.webp"
            alt="Dashboard principal" style="width: 50%; max-width: 1200px; margin: 0 auto; display: block;">
        
        <br />
        
        <!-- Dashboard de Metabase para Proveedores y Prestadores -->
        <div v-if="perfil === 'Proveedor' && dashboardUrl">
            <!-- Dashboard para proveedores (con filtro por id_proveedor) -->
            <iframe 
                :src="dashboardUrl" 
                width="100%" 
                height="600"
                frameborder="0"
                allowtransparency>
            </iframe>
        </div>
        <div v-else-if="perfil === 'Prestador'">
            <!-- Dashboard para prestadores (sin filtro, todos los datos) -->
            <iframe 
                src="/metabase/public/dashboard/15120a18-57de-46cb-b857-cd9506b902d6" 
                width="100%" 
                height="600"
                frameborder="0"
                allowtransparency>
            </iframe>
        </div>


    </div>
</template>
<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import HeaderGeneral from "../components/HeaderGeneral.vue";
export default {
    name: "Inicio",
    components: {
        HeaderGeneral
    },
    props: [
        "dataAnalytics",
        "trazado119",
        "she",
        "overlapGroup17",
        "trazado200",
        "trazado201",
        "trazado122",
        "trazado203",
        "trazado204",
        "iconCursor",
        "trazado202",
        "trazado118",
        "iconBookmark",
        "grupo139",
        "articulacinDeRuta",
        "trazado176",
        "p2H",
        "trazado173",
        "health2",


    ],
    data() {
        return {
            vista: "Dashboard",
            carpeta: "",
            proveniente: "",
            atras: false,
            datos: [{
                "id": 0,
                "title": "Articulación de rutas integrales en salud",

            },
            {
                "id": 1,
                "title": "P2H",
            },
            {
                "id": 2,
                "title": "DATA ANALYTICS",
            },
            {
                "id": 3,
                "title": "SHE",
            },
            ],
            perfil: null,
            datausuario: null,
            dashboardUrl: null
        }
    },
    async created() {
        const usuarioData = localStorage.getItem('user');
        if (usuarioData) {
            try {
                const usuario = JSON.parse(usuarioData);
                this.datausuario = usuario;
                this.perfil = usuario.nombre_perfil;
                console.log("perfil>>", this.perfil);
                
                // Si es proveedor, construir URL con parámetro dinámico
                if (this.perfil === 'Proveedor' && usuario.id_proveedor) {
                    this.dashboardUrl = `/metabase/public/dashboard/15120a18-57de-46cb-b857-cd9506b902d6?id_proveedor=${usuario.id_proveedor}`;
                    console.log("Dashboard URL:", this.dashboardUrl);
                }
            } catch (e) {
                console.error('Error al parsear los datos del usuario desde localStorage:', e);
                this.perfil = 'Desconocido';
            }
        } else {
            console.warn('No se encontraron datos del usuario en localStorage.');
            this.perfil = 'Desconocido';
        }
    },
    methods: {
        async ingreso() {

        }
    }
};
</script>

<style>
.paddincard {
    padding-top: 10%;
}

.center {
    text-align: center;
}

.total {
    margin-top: -35%;
    margin-bottom: 8%;
}

.carddas {
    box-shadow: 4px 3px 3px #02309270;
    border-color: 2px solid #02309270 !important;
}

.iconocard {
    color: #02309270;
    margin-left: 6%;
    width: 80%;
}

.regisTituloUsuario {
    font-size: 20px !important;
    text-align: left !important;
    font-weight: 100 !important;
    color: var(--blue-violet);
}
</style>
